 <template>
    <div class="alet_container">
	    <section class="tip_text_container">
            <div class="ys" @click="closeTip">
                <i class="el-icon-error"></i>
            </div>
            <p class="tip_text" v-html="alertText"></p>
            <div class="confrim" @click="confrim">
                <p>{{confrimText || '确认'}}</p>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
    	data(){
            return{
                positionY: 0,
                timer: null
            }
        },
        props: ['alertText', 'confrimText', 'confrimUrl'],
        methods: {
            confrim() {
                if(this.confrimUrl) {
                  window.location.href = this.confrimUrl;
                }
                this.$emit('closeTip')
            },
            closeTip(){
                this.$emit('closeTip')
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/css/mixin';
	@keyframes tipMove{
       0%   { transform: translateX(-50%) scale(1) }
       35%  { transform: translateX(-50%) scale(.8) }
       70%  { transform: translateX(-50%) scale(1.1) }
       100% { transform: translateX(-50%) scale(1) }
    }
    .alet_container{
    	position: fixed;
    	top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
    }
    .tip_text_container{
        position: absolute;
        top: 10%;
        left: 50%;
        transform:translateX(-50%);
        -webkit-transform:translateX(-50%);
        width: 17rem;
        animation: tipMove .4s ;
        -webkit-animation: tipMove .4s ;
        background-color: rgba(255,255,255,1);
        border: 1px;
        border: 1px;
        border-radius: 0.25rem;
        .el-icon-error{
            position: absolute;
            // display: block;
            top: 6px;
            right: 6px;
        }
        .tip_icon{
            @include wh(3rem, 3rem);
            border: 0.15rem solid #f8cb86;
            border-radius: 50%;
            margin: 0 auto;
            span:nth-of-type(1){
                @include wh(.12rem, 1.5rem);
                background-color: #f8cb86;
                display: block;
                margin-left: 1.3rem;
                margin-top: 0.2rem;
            }
            span:nth-of-type(2){
                @include wh(.2rem, .2rem);
                border: 1px;
                border-radius: 50%;
                margin-top: .2rem;
                background-color: #f8cb86;
                display: block;
                margin-left: 1.27rem;
            }
        }
        .tip_text{
            @include sc(.7rem, #333);
            line-height: .9rem;
            text-align: center;
            margin-top: .8rem;
            padding: 1.5rem 2em;
        }
        .confrim{
            @include sc(.8rem, #fff);
            font-weight: bold;
            margin-top: .8rem;
            width: 100%;
            text-align: center;
            line-height: 1.8rem;
            border: 1px;
            border-bottom-left-radius: 0.25rem;
            border-bottom-right-radius: 0.25rem;
        }
        .confrim p{
            @include sc(.8rem, #e21843);
            font-weight: bold;
            margin: 0 auto;
            background-color: #fde338;
            width: 30%;
            text-align: center;
            line-height: 1.8rem;
            border-radius: 5px;
            margin-bottom: 1rem;
        }
        .ys{
            color: #e21843;
            position: absolute;
            top: -5px;
            right: 0px;
            background-color: #fff;
            border-radius: 50%;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/alertTip.vue